import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';

import { useSessionData } from '@confluence/session-data';

const NewUserQuery = gql`
	query useIsNewUserQuery($cloudId: String!, $userId: String!) @experimental {
		experimentalSiteUserPersonalization(cloudId: $cloudId, userId: $userId) {
			attributes {
				name
				value
			}
		}
	}
`;

const CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';

//THE GA Date of USD, any users onboarding on or after this date are considered new users
const NEW_USER_FROM_DATE = new Date('2025-03-24');

export const useIsNewUser = () => {
	const { cloudId, userId } = useSessionData();

	const { data, loading, error } = useQuery(NewUserQuery, {
		variables: { cloudId, userId },
		skip: !userId || !cloudId,
	});

	if (loading || error) {
		return {
			isNewUser: true,
		};
	}

	const attributes = data?.experimentalSiteUserPersonalization?.attributes;

	const firstActiveValue = attributes?.find(
		({ name }: { name: string }) => name === CONFLUENCE_FIRST_ACTIVE_TRAIT,
	)?.value;
	const firstActiveDate = new Date(firstActiveValue);
	const isNewUser = Boolean(firstActiveDate >= NEW_USER_FROM_DATE);

	return {
		isNewUser,
	};
};
